import api from './api';

/**
 * Servicios para operaciones y parámetros (accesibles por usuarios normales)
 */

/**
 * Obtener parámetros searchable agrupados por operación.
 * Solo devuelve las operaciones habilitadas para la cuenta del usuario.
 *
 * @returns {Promise<{operations: Array<{id: number, key: string, name: string, params: Array}>}>}
 */
export const getSearchableParamsGrouped = async () => {
  const response = await api.get('/operations/params/searchable');
  return response.data;
};

/**
 * Obtener las operaciones habilitadas para la cuenta del usuario.
 *
 * @returns {Promise<{operations: Array<{id: number, key: string, name: string}>}>}
 */
export const getEnabledOperations = async () => {
  const response = await api.get('/operations/enabled');
  return response.data;
};
